var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import "./textField.styles.scss";
var crossIcon = require("../../assets/images/crossIcon.png");
var TextField = function (props) {
    var _a = React.useState(""), value = _a[0], setValue = _a[1];
    React.useEffect(function () {
        setValue(function (value) { return props.value || ""; });
    }, [props.value]);
    var onTextChange = function (event) {
        var onChange = props.onChange, onChangeEvent = props.onChangeEvent;
        var value = event.target.value;
        setValue(value);
        onChangeEvent && onChangeEvent(event);
        onChange && onChange(event.target.value);
    };
    var onClear = function (event) {
        var onClear = props.onClear;
        setValue("");
        onClear && onClear();
    };
    var input = props.input, label = props.label, type = props.type, disabled = props.disabled, pattern = props.pattern, isClearable = props.isClearable, addBefore = props.addBefore, addAfter = props.addAfter, rest = __rest(props, ["input", "label", "type", "disabled", "pattern", "isClearable", "addBefore", "addAfter"]);
    return (React.createElement("div", { className: "input-field-container" },
        label && (React.createElement("label", { className: "input-field-label" },
            label,
            React.createElement("span", { className: "required-indicator" }, props.required ? "*" : ""))),
        React.createElement("div", { className: "input-container " + (disabled ? "disabled" : "") },
            addBefore && React.createElement("div", { className: "addon-before-container" }, addBefore),
            React.createElement("input", __assign({ pattern: pattern, className: "input-field", type: type, disabled: disabled, value: value }, rest, { onChange: onTextChange })),
            isClearable && onClear && (React.createElement("button", { onClick: onClear, className: "clear-btn" },
                React.createElement("img", { src: crossIcon, alt: "clear" }))),
            addAfter && React.createElement("div", { className: "addon-after-container" }, addAfter))));
};
export default TextField;
//# sourceMappingURL=textField.js.map